// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"127be8e2","455":"3b85466c","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};